import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, isFetching } from './common';
import { sendError } from '../sendError';

const name = 'contractorIncidentReport';

export type IncidentReportInfo = {
  automationId: string;
  clientOrganizationId: string;
};

export const fetchContractorIncidentReport = createAsyncThunk(
  `${name}/fetch`,
  async ({ contractorId }: { contractorId: string }) => {
    try {
      const { data } = await axios.get<IncidentReportInfo>(
        `/api/processautomation/v1.0/contractors/${contractorId}/incident-report-info`
      );
      return data;
    } catch (error) {
      if ((error as any)?.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }
);

export type State = CommonState & {
  incidentReportInfo: IncidentReportInfo | null;
  hasFetched: boolean;
};

const initialState: State = {
  error: null,
  isFetching: false,
  incidentReportInfo: null,
  hasFetched: false
};

const contractorIncidentReport = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchContractorIncidentReport.pending, isFetching)
      .addCase(fetchContractorIncidentReport.fulfilled, (state, action) => {
        state.incidentReportInfo = action.payload;
        state.isFetching = false;
        state.hasFetched = true;
      })
      .addCase(fetchContractorIncidentReport.rejected, (state, action) => {
        state.isFetching = false;
        state.hasFetched = true;
        sendError(action.error);
      });
  }
});

export const { reducer: contractorIncidentReportReducer } = contractorIncidentReport;
